import StatisticComponent from './StatisticComponent';
export default StatisticComponent;